/* Vaelor vehicle finder: Year > Make > Model > Trim, backed by vaelor-vehicles.json */
(function () {
  var KEY = 'vp_vehicle';
  var indexPromise = null;

  function loadIndex(url) {
    if (!indexPromise) {
      indexPromise = fetch(url).then(function (r) {
        if (!r.ok) throw new Error('vehicle index ' + r.status);
        return r.json();
      }).catch(function (e) { indexPromise = null; throw e; });
    }
    return indexPromise;
  }

  function getSaved() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function setSaved(v) {
    try { v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY); } catch (e) {}
  }

  function sortNat(a) {
    return a.slice().sort(function (x, y) { return x.localeCompare(y, undefined, { numeric: true, sensitivity: 'base' }); });
  }

  function fill(select, placeholder, values, keepDisabled) {
    select.innerHTML = '';
    var o = document.createElement('option');
    o.value = ''; o.textContent = placeholder;
    select.appendChild(o);
    values.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = v; opt.textContent = v;
      select.appendChild(opt);
    });
    select.disabled = !!keepDisabled || values.length === 0;
  }

  function tagFor(v, trim) {
    return [v.make, v.model, trim, v.year].filter(Boolean).join(' ');
  }

  function label(v) {
    return [v.year, v.make, v.model, v.trim].filter(Boolean).join(' ');
  }

  function buildUrl(searchUrl, idx, v) {
    var trims = v.trim ? [v.trim] : ((((idx.y[v.year] || {})[v.make] || {})[v.model]) || ['']);
    var q = trims.map(function (t) { return 'tag:"' + tagFor(v, t) + '"'; }).join(' OR ');
    return searchUrl + '?type=product&options%5Bprefix%5D=none&q=' + encodeURIComponent(q);
  }

  function init(form) {
    var sy = form.querySelector('[data-vpvf-year]');
    var sm = form.querySelector('[data-vpvf-make]');
    var sd = form.querySelector('[data-vpvf-model]');
    var st = form.querySelector('[data-vpvf-trim]');
    var btn = form.querySelector('[data-vpvf-submit]');
    var clr = form.querySelector('[data-vpvf-clear]');
    var searchUrl = form.dataset.searchUrl || '/search';
    var idx = null;

    sy.options[0].textContent = 'Loading…';

    function refreshButton() { btn.disabled = !(sy.value && sm.value && sd.value); }

    function onYear() {
      var makes = sy.value ? sortNat(Object.keys(idx.y[sy.value] || {})) : [];
      fill(sm, 'Make', makes, !sy.value);
      fill(sd, 'Model', [], true);
      fill(st, 'All trims', [], true);
      refreshButton();
    }
    function onMake() {
      var models = (sy.value && sm.value) ? sortNat(Object.keys((idx.y[sy.value] || {})[sm.value] || {})) : [];
      fill(sd, 'Model', models, !sm.value);
      fill(st, 'All trims', [], true);
      refreshButton();
    }
    function onModel() {
      var trims = (sy.value && sm.value && sd.value) ? ((idx.y[sy.value] || {})[sm.value] || {})[sd.value] || [] : [];
      var named = sortNat(trims.filter(Boolean));
      fill(st, 'All trims', named, !sd.value || named.length === 0);
      refreshButton();
    }

    function applySaved(v) {
      if (!v || !idx.y[v.year]) return;
      sy.value = v.year; onYear();
      if (!(idx.y[v.year] || {})[v.make]) return;
      sm.value = v.make; onMake();
      if (!((idx.y[v.year] || {})[v.make] || {})[v.model]) return;
      sd.value = v.model; onModel();
      if (v.trim) st.value = v.trim;
      refreshButton();
      clr.hidden = false;
    }

    loadIndex(form.dataset.indexUrl).then(function (data) {
      idx = data;
      var years = Object.keys(idx.y).sort(function (a, b) { return b - a; });
      fill(sy, 'Year', years, false);
      applySaved(getSaved());
    }).catch(function () {
      sy.options[0].textContent = 'Vehicle list unavailable';
    });

    sy.addEventListener('change', onYear);
    sm.addEventListener('change', onMake);
    sd.addEventListener('change', onModel);
    st.addEventListener('change', refreshButton);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idx || !(sy.value && sm.value && sd.value)) return;
      var v = { year: sy.value, make: sm.value, model: sd.value, trim: st.value || '' };
      v.label = label(v);
      setSaved(v);
      window.location.href = buildUrl(searchUrl, idx, v);
    });

    clr.addEventListener('click', function () {
      setSaved(null);
      clr.hidden = true;
      if (idx) { sy.value = ''; onYear(); }
      document.querySelectorAll('[data-vp-vehicle-label]').forEach(function (el) { el.textContent = 'your vehicle'; });
    });
  }

  function labelResults() {
    var v = getSaved();
    if (!v || !v.label) return;
    document.querySelectorAll('[data-vp-vehicle-label]').forEach(function (el) { el.textContent = v.label; });
  }

  function start() {
    document.querySelectorAll('[data-vpvf]').forEach(function (f) {
      if (f.dataset.vpvfInit) return;
      f.dataset.vpvfInit = '1';
      init(f);
    });
    labelResults();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();